module.exports = window.dnn.nodeModules.ReactCustomScrollBars;